export enum EUserReferralQueryKey {
  GET_REFERRAL_CODES = 'get-referral-codes',
  GET_REFERRAL_LIST = 'get-referral-list',
  GET_LOYALTY_TRANSACTION_HISTORY = 'get-loyalty-transaction-history',
  GET_LOYALTY_MISSIONS = 'get-loyalty-missions',
  GET_LOYALTY_PORTFOLIO = 'get-loyalty-portfolio',
}
